var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-component'),_vm._v(" "),_c('sidebar-component'),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_vm._t("default"),_vm._v(" "),_c('footer-component')],2),_vm._v(" "),_c('div',{staticClass:"custom-modal-backdrop"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-629598c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/UserLayout.vue
// module id = null
// module chunks = 